import React from 'react'

const FAQTab = () => {
    return (
        <li>

            <h4 className="my-4"> Course Faq</h4>

            <ul className="course-faq" uk-accordion="">

                <li className="uk-open">
                    <a className="uk-accordion-title" href="#"> Html Introduction </a>
                    <div className="uk-accordion-content">
                        <p> The primary goal of this quick start guide is to introduce you to
                        Unreal
                        Engine 4`s (UE4) development environment. By the end of this guide,
                        you`ll
                        know how to set up and develop C++ Projects in UE4. This guide shows
                        you
                        how
                        to create a new Unreal Engine project, add a new C++ class to it,
                        compile
                        the project, and add an instance of a new class to your level. By
                        the
                        time
                        you reach the end of this guide, you`ll be able to see your
                        programmed
                        Actor
                                floating above a table in the level. </p>
                    </div>
                </li>

                <li>
                    <a className="uk-accordion-title" href="#"> Your First webpage</a>
                    <div className="uk-accordion-content">
                        <p> The primary goal of this quick start guide is to introduce you to
                        Unreal
                        Engine 4`s (UE4) development environment. By the end of this guide,
                        you`ll
                        know how to set up and develop C++ Projects in UE4. This guide shows
                        you
                        how
                        to create a new Unreal Engine project, add a new C++ class to it,
                        compile
                        the project, and add an instance of a new class to your level. By
                        the
                        time
                        you reach the end of this guide, you`ll be able to see your
                        programmed
                        Actor
                                floating above a table in the level. </p>
                    </div>
                </li>

                <li>
                    <a className="uk-accordion-title" href="#"> Some Special Tags </a>
                    <div className="uk-accordion-content">
                        <p> The primary goal of this quick start guide is to introduce you to
                        Unreal
                        Engine 4`s (UE4) development environment. By the end of this guide,
                        you`ll
                        know how to set up and develop C++ Projects in UE4. This guide shows
                        you
                        how
                        to create a new Unreal Engine project, add a new C++ class to it,
                        compile
                        the project, and add an instance of a new class to your level. By
                        the
                        time
                        you reach the end of this guide, you`ll be able to see your
                        programmed
                        Actor
                                floating above a table in the level. </p>
                    </div>
                </li>

                <li>
                    <a className="uk-accordion-title" href="#"> Html Introduction </a>
                    <div className="uk-accordion-content">
                        <p> The primary goal of this quick start guide is to introduce you to
                        Unreal
                        Engine 4`s (UE4) development environment. By the end of this guide,
                        you`ll
                        know how to set up and develop C++ Projects in UE4. This guide shows
                        you
                        how
                        to create a new Unreal Engine project, add a new C++ class to it,
                        compile
                        the project, and add an instance of a new class to your level. By
                        the
                        time
                        you reach the end of this guide, you`ll be able to see your
                        programmed
                        Actor
                                floating above a table in the level. </p>
                    </div>
                </li>

            </ul>

        </li>

    )
}

export default FAQTab
